import React from 'react';
import Button, { LoadingButton } from '@atlaskit/button';
import { Box, Flex, xcss } from '@atlaskit/primitives';
import { useIntl } from '@atlassian/jira-intl';
import { ImportErrorMessage } from '../import-error-message';
import messages from './messages';
import type { StepFooterProps } from './types';

export const StepFooter = ({
	onReturn,
	shouldStartImportOnNext = false,
	isLoading = false,
	shouldDisableNext = false,
	shouldDisableReturn = false,
	nextButtonType = 'button',
	onClickNext,
	shouldRenderNextButton = true,
	hasImportErrorOccurred = false,
	backButtonMessage = messages.back,
	alignRight = false,
}: StepFooterProps) => {
	const { formatMessage } = useIntl();

	return (
		<>
			{hasImportErrorOccurred && <ImportErrorMessage />}
			<Flex gap="space.100" justifyContent={alignRight ? 'end' : 'start'}>
				<Button
					onClick={onReturn}
					isDisabled={shouldDisableReturn}
					testId="project-create-importer-upload-flow.common.ui.step-footer.back-button"
				>
					{formatMessage(backButtonMessage)}
				</Button>
				{shouldRenderNextButton && (
					<LoadingButton
						testId="project-create-importer-upload-flow.common.ui.step-footer.next-button"
						type={nextButtonType}
						onClick={onClickNext}
						appearance="primary"
						isLoading={isLoading}
						isDisabled={shouldDisableNext}
					>
						{shouldStartImportOnNext
							? formatMessage(messages.import)
							: formatMessage(messages.next)}
					</LoadingButton>
				)}
			</Flex>
		</>
	);
};

export const StepFooterStandard = ({
	isFixedPosition = true,
	hasImportErrorOccurred,
	...otherProps
}: StepFooterProps) => (
	<>
		{hasImportErrorOccurred && <ImportErrorMessage />}
		<Box
			xcss={[wrapperStyles, ...(isFixedPosition ? [wrapperWithFixedPosition] : [])]}
			testId="project-create-importer-upload-flow.common.ui.step-footer.wrapper"
		>
			<Box xcss={buttonsWrapper}>
				<StepFooter {...otherProps} />
			</Box>
		</Box>
	</>
);

const wrapperStyles = xcss({
	display: 'flex',
	alignItems: 'center',
	height: '64px',
	width: '100%',
	borderTopWidth: 'space.025',
	borderTopColor: 'color.border',
	borderTopStyle: 'solid',
	backgroundColor: 'color.background.input',
});

const wrapperWithFixedPosition = xcss({
	position: 'fixed',
	bottom: 'space.0',
	left: 'space.0',
});

const buttonsWrapper = xcss({
	width: '80%',
	maxWidth: '1008px',
	margin: 'auto',
});
